module.exports = __webpack_public_path__ + "static/vista-11-6bb3e95ffb6f1401b6f1223b37ae0290.png";